import { render, staticRenderFns } from "./WorkFlosMonitoring.vue?vue&type=template&id=015d4b2b&scoped=true&"
import script from "./WorkFlosMonitoring.vue?vue&type=script&lang=js&"
export * from "./WorkFlosMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015d4b2b",
  null
  
)

export default component.exports